<template>
    <div id="app">
        <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    provide() {
        return {
            reload: this.reload
        }
    },
    data() {
        return {
            isRouterAlive: true
        }
    },
    mounted() {
        window.localStorage.removeItem('beforeJumpUrl')
        window.sessionStorage.removeItem('beforeJumpUrl')
    },
    methods: {
        //页面重新载入函数
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            })
        }
    },
    beforeDestroy() {
        sessionStorage.removeItem('beforeJumpUrl');
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue